document.addEventListener('DOMContentLoaded', function () {
	//console.log('DOMContentLoaded');
	// wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener("load", function(e) {

		/**
		 * Loading animation
		 */
		const mainNav = document.querySelector('.top-nav')
		const banner  = document.querySelector('.banner')

		var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

		if ( scrollTop < window.innerHeight && banner?.classList.contains( 'banner--media' ) ) {
			// Variables to be animated.
			const bannerBlockYellow       = document.querySelector( '.banner .block-yellow' )
			const bannerBlockOrange       = document.querySelector( '.banner .block-orange' )
			const bannerAnimatedBlockPH   = document.querySelector( '.banner .animated-block-placeholder' )
			const bannerAnimatedBlockData = document.querySelector( '.banner .animated-block-data' )
			const bannerVerticalLine      = document.querySelector( '.banner .vertical-line-green' )
			const bannerTitle             = document.querySelector( '.banner__title' )
			const bannerTitleLines        = document.querySelectorAll( '.banner__title .line' )
			const bannerTitleLinesBefore  = CSSRulePlugin.getRule( 'html.js .banner.banner--media .banner__title .line:before' ) // it needs to match exactly the CSS rule.
			const bannerIntro             = document.querySelector( '.banner__intro' )
			const bannerScrollTo          = document.querySelector( '.banner .scroll-to' )
			const bannerImage             = document.querySelector( '.banner__image-container' )
			const bannerBreadcrumb        = document.querySelector( '.banner__breadcrumb' )

			const mainContent             = document.querySelector( 'main.main' )
			
			new SplitText(bannerTitle, {type:"lines", linesClass:"line line++"});

			// Init
			gsap.set( bannerBlockYellow, { width: 0 } )
			gsap.set( bannerBlockOrange, { width: 0 } )
			gsap.set( bannerAnimatedBlockData, { opacity: 0 } )
			gsap.set( bannerAnimatedBlockPH, { width: 0 } )
			gsap.set( bannerVerticalLine, { height: 0 } )

			gsap.set( bannerIntro, { opacity: 0 } )
			gsap.set( bannerScrollTo, { opacity: 0 } )
			gsap.set( bannerImage, { opacity: 0 } )
			gsap.set( bannerBreadcrumb, { opacity: 0 } )

			gsap.set( mainContent, { opacity: 0 } )
			
			let loadingTL = gsap.timeline({ ease: "expo.out" })

			loadingTL
				.to( banner, { opacity: 1 } )
				.to( bannerTitleLinesBefore, { cssRule: { right: '0%' }, duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' } )
				.to( bannerTitle, { 'color': '#0A0A0A'} )
				.to( bannerTitleLinesBefore, { cssRule: { left: '110%' }, duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' } )
				.to( bannerBlockYellow, { width: '100%', duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' }, '<' )
				.to( bannerBlockOrange, { width: '100%', duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' }, '<' )
				.to( bannerVerticalLine, { height: '100%', duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' }, '<' )
				.to( bannerAnimatedBlockPH, { width: '100%', duration: 0.6, ease: '0.66, 0.00, 0.34, 1.00' }, '<' )
				.fromTo( bannerAnimatedBlockData, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' } )
				.to( bannerAnimatedBlockPH, { opacity: 0 }, '<' )
				.fromTo( bannerIntro, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' }, '<' )
				.fromTo( bannerScrollTo, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' }, '<' )
				.fromTo( bannerImage, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' }, '<' )
				.fromTo( bannerBreadcrumb, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' }, '<' )
				.fromTo( mainNav, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' } )
				.fromTo( mainContent, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: '0.32, 0.47, 0.60, 1.00' } )
		} else {
			const bannerTitle = document.querySelector( '.banner__title' )
			const bannerAnimatedBlockPH   = document.querySelector( '.banner .animated-block-placeholder' )

			mainNav.style.opacity = 1

			if ( banner ) {
				banner.style.opacity = 1
				bannerTitle.style.color = '#0A0A0A'

				if ( bannerAnimatedBlockPH ){
					bannerAnimatedBlockPH.style.opacity = 0
				}
			}
		}






		/**
		 * Reveal image
		 */
		let revealContainers = document.querySelectorAll(".reveal");

		revealContainers.forEach((container) => {
			let image = container.querySelector("img");

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: container,
					once: true
				}
			});

			tl.set(container, { autoAlpha: 1 });
			tl.from(container, 1.8, { xPercent: -100, ease: Power2.out });
			tl.from(image, 1.8, { xPercent: 100, scale: 1, delay: -1.8, ease: Power2.out });
		});


		/**
		 * Video Cursor
		 */
		if (
			document.querySelectorAll( '.block--video' ).length > 0 ||
			document.querySelectorAll( '.teaser--video' ).length > 0
		) {
			function setInitialCursorPosition(videoTeaser) {
				const cursor = videoTeaser.querySelector('.cursor-content')

				cursor.style.transform = `translate(${videoTeaser.offsetWidth / 2}px, ${videoTeaser.offsetHeight / 2}px)`
				cursor.style.opacity = 1
			}

			function handleMouseMove(e) {
				//console.log('Mouse Move');
				const cursor = e.target.parentNode.querySelector('.cursor-content');

				if (document.body.classList.contains('page-template-tpl-home') || document.body.classList.contains('page-template-tpl-virtual-tour')) {
					gsap.to( cursor, { x: e.clientX, y: e.clientY, duration: 0.5 } );
				} else {
					gsap.to( cursor, { x: e.layerX, y: e.layerY, duration: 0.5 } );
				}
			}

			function handleMouseLeave(e) {
				//console.log('Mouse leave');
				const cursor = e.target.parentNode.querySelector('.cursor-content');
				const x = this.offsetWidth / 2;
				const y = this.offsetHeight / 2;

				gsap.to( cursor, { x: x, y: y, duration: 1, ease: 'power3.out' } );
			}

			function VideoCursor() {
				//console.log('Video cursor loaded');
				const videoTeasers = document.querySelectorAll('.js-cursor-content');

				if ( ! videoTeasers ) return;

				videoTeasers.forEach(videoTeaser => {
					//console.log(videoTeaser);
					setInitialCursorPosition(videoTeaser);
					window.addEventListener('load', () => setInitialCursorPosition(videoTeaser));

					if ( window.innerWidth < 768) return

					videoTeaser.parentNode.addEventListener('mousemove', handleMouseMove);
					videoTeaser.parentNode.addEventListener('wheel', handleMouseMove);
					videoTeaser.parentNode.addEventListener('mouseleave', handleMouseLeave);
				})
			}

			VideoCursor();
		}


	}, false);
});
